import { render, staticRenderFns } from "./CurrentConversation.vue?vue&type=template&id=77541486&scoped=true&"
import script from "./CurrentConversation.vue?vue&type=script&lang=js&"
export * from "./CurrentConversation.vue?vue&type=script&lang=js&"
import style0 from "./CurrentConversation.vue?vue&type=style&index=0&id=77541486&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77541486",
  null
  
)

export default component.exports